/**
 * ES6 Promise Polyfill
 */
import 'es6-promise/auto';

/**
 * Vuex
 */
// window.Vuex = require("vuex");
// Vue.use(Vuex);

window.axios.defaults.headers.get['Accept'] = 'application/json';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';
//
// window.io = require('socket.io-client');
// let bearerToken = '';
//
// window.Echo = new Echo({
// 	broadcaster: 'socket.io',
// 	host: window.Spark.socket_location,
// 	auth: {
// 		headers: {
// 			Authorization: 'Bearer ' + bearerToken,
// 		},
// 	},
// });

/**
 * Import Font Awesome library based on the environment
 */
if (process.env.npm_lifecycle_event !== 'production') {
	// Dev Only! Imports ALL Icons
	require('./font-awesome/dev');
} else {
	require(`./font-awesome/production`);
}

// Custom Icons
require(`./font-awesome/custom`);

import {
	FontAwesomeIcon,
	FontAwesomeLayers,
	FontAwesomeLayersText,
} from '@fortawesome/vue-fontawesome';

Vue.component('fa-icon', FontAwesomeIcon);
Vue.component('fa-layers', FontAwesomeLayers);
Vue.component('fa-layers-text', FontAwesomeLayersText);
